<section class="section home-scrollbar section-top section-full" style="background-image: url(assets/photos/home/title_photo.jpg); background-size: cover" id="home">
  <div class="container" id="home2">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-8 col-lg-7">
        <h1 class="text-white text-center mb-4 animate">REKLAMA, KTORÚ NEVYPNEŠ</h1>
        <p class="lead text-white text-muted text-center mb-5 animate">
          Vyberte si zo širokej ponuky reklamných plôch a reklamných predmetov
        </p>
        <p class="text-center mb-0 animate">
          <a class="btn btn-outline-light pr-5 pl-5" style="font-size: 13px; color: white;"
             onmouseover="this.style='font-size: 13px; color: black; background: #b4c3ff;';"
             onmouseout="this.style='font-size: 13px; color: white'"
             [routerLink]="['/contacts']" fragment="kontakt" (click)="closeNavBar()">
            Kontakt
          </a>
        </p>
      </div>
    </div>
  </div>
</section>
